import { AlertTriangle, Info } from "lucide-react";
import { Link } from "@tanstack/react-router";

type Variant = "default" | "compact" | "highlight";

export function Disclaimer({ variant = "default" }: { variant?: Variant }) {
  if (variant === "compact") {
    return (
      <p className="rounded-md border border-border bg-muted/50 px-3 py-2 text-xs text-muted-foreground">
        <Info className="mr-1.5 inline h-3.5 w-3.5 text-gold align-[-2px]" />
        Nkadimeng Danny is <strong className="text-foreground">not an admitted attorney</strong>.
        We provide <strong className="text-foreground">legal information, legal advice on non-reserved matters and legal opinions</strong> — we do not take reserved work or represent clients in court.{" "}
        <Link to="/disclaimer" className="underline hover:text-navy">Read full disclaimer</Link>.
      </p>
    );
  }

  if (variant === "highlight") {
    return (
      <aside className="rounded-xl border-l-4 border-gold bg-gold/10 p-5 text-sm text-foreground">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
          <div className="space-y-2">
            <p className="font-display text-base text-navy">Important — please read</p>
            <p className="leading-relaxed">
              <strong>Nkadimeng Danny is an LLB graduate and is not an admitted
              attorney of the High Court of South Africa.</strong> This practice
              provides <strong>legal information, legal advice on non-reserved
              matters, legal opinions, paralegal support and compliance
              services</strong> — we do not undertake work reserved by the Legal
              Practice Act 28 of 2014, do not represent clients in formal court
              proceedings, and do not hold a Fidelity Fund Certificate.
            </p>
            <p className="leading-relaxed text-muted-foreground">
              Advice and information we provide is limited to non-reserved
              matters. Where a matter is reserved or requires admitted-attorney
              representation, we will refer you to a suitable practitioner.
            </p>
            <p>
              <Link to="/disclaimer" className="text-navy underline hover:text-gold">
                Read the full disclaimer, scope of services & POPIA notice →
              </Link>
            </p>
          </div>
        </div>
      </aside>
    );
  }

  return (
    <div className="rounded-lg border border-border bg-secondary/40 p-4 text-sm text-muted-foreground">
      <p>
        <Info className="mr-1.5 inline h-4 w-4 text-gold align-[-3px]" />
        <strong className="text-foreground">Legal advice on non-reserved matters.</strong>{" "}
        Nkadimeng Danny is not an admitted attorney. We provide legal
        information, legal advice on non-reserved matters, legal opinions,
        paralegal support and compliance services. For reserved matters or
        court representation we will refer you appropriately.{" "}
        <Link to="/disclaimer" className="underline hover:text-navy">Full disclaimer</Link>.
      </p>
    </div>
  );
}

